import { render, staticRenderFns } from "./PageArticle.vue?vue&type=template&id=62d631b2&"
import script from "./PageArticle.vue?vue&type=script&lang=js&"
export * from "./PageArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports